import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';
import { BuyNow } from '~/views/organisms/buy.now';
import { HowItWork } from '~/views/organisms/how.it.work';
import { Promotional } from '~/views/organisms/promotional';

export const PageHome: FC = observer(() => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <BuyNow />
            <HowItWork />
            {false && <Promotional />}
        </>
    );
});
